__turbopack_context__.v({
  "ContentWrapper": "BrandedImageTeaser-module-scss-module__0i3kCq__ContentWrapper",
  "HelpTitle": "BrandedImageTeaser-module-scss-module__0i3kCq__HelpTitle",
  "IconsWrapper": "BrandedImageTeaser-module-scss-module__0i3kCq__IconsWrapper",
  "ImageWrapper": "BrandedImageTeaser-module-scss-module__0i3kCq__ImageWrapper",
  "LogoWrapper": "BrandedImageTeaser-module-scss-module__0i3kCq__LogoWrapper",
  "Wrapper": "BrandedImageTeaser-module-scss-module__0i3kCq__Wrapper",
});
